// The pourpose of this component is to trigger an intentional error to test Sentry error tracking

const SentryErrorPage = () => {
    throw new Error(
        'This is an intentional error to test Sentry error tracking.'
    );
};

export default SentryErrorPage;
